import type { UserManagementGateway } from '@/userManagement/infrastructure/rest/userManagementApi';
import { userManagementApi } from '@/userManagement/infrastructure/rest/userManagementApi';

/**
 * Single access point for UM HTTP from application adapters.
 * Keeps infrastructure import localized here; tests may override via {@link setUserManagementGatewayForTests}.
 */
let testOverride: UserManagementGateway | null = null;

export function getUserManagementGateway(): UserManagementGateway {
  return testOverride ?? userManagementApi;
}

/** @internal Vitest — restore with `null` after each test. */
export function setUserManagementGatewayForTests(gateway: UserManagementGateway | null): void {
  testOverride = gateway;
}

export type { UserManagementGateway } from '@/userManagement/infrastructure/rest/userManagementApi';
